<template>
  <div class="page-not-found">
    <img src="../assets/image/common/404img.png" alt="404">
    <p class="tip">您访问的页面丢失啦</p>
    <router-link tag="div" to="/" class="btn">返回首页</router-link>
    <!--<div class="btn">返回首页</div>-->
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
  @import "../styles/mixin.scss";

  .page-not-found {
    padding-top: px2rem(220);
    text-align: center;
    img {
      width: 100%;
    }
    .tip {
      margin-top: px2rem(80);
      color: #c8c8c8;
      font-size: px2rem(40);
    }
    .btn {
      display: inline-block;
      margin-top: px2rem(60);
      width: px2rem(320);
      height: px2rem(80);
      line-height: px2rem(80);
      background: #c80032;
      border-radius: px2rem(6);
      color: #fff;
      text-align: center;
    }
  }
</style>
